import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {  initialAddressState } from "../../types/addressType"
import { api } from "../../config/Api"
import { ApiResponse } from "../../types/apiResponse"
import { Address } from "../../types/userType"

const BASE_URL="/api/address"
export const addNewAddress = createAsyncThunk<Address,Address,{rejectValue:null}>("addresses/addNewAddress",
    async(req,{rejectWithValue})=>{
        try {
            const response = await api.post(`${BASE_URL}/add`,req)
            
            return response.data
        } catch (error:any) {
      
           return rejectWithValue(
            error.response?.data.message|| "Failed to load Cart"
           )
    }
    }
)

export const deleteAddress = createAsyncThunk<Address,number,{rejectValue:null}>(
    "addresses/deleteAddress",
    async(addressId,{rejectWithValue})=>{
        try {
            const response = await api.delete<Address>(`${BASE_URL}/delete/${addressId}`)
         
            return response.data
        } catch (error:any) {
        
            return rejectWithValue(
                error.response.data.message
            )
        }
    }
)

export const fetchAllAddress = createAsyncThunk<Address[],void,{rejectValue:null}>(
    "/addresses/fetchAllAddress",
    async(_,{rejectWithValue})=>{
        try {
            const response = await api.get(`${BASE_URL}`)
        
        return response.data;
        } catch (error:any) {
            
            return rejectWithValue(
                error.response.data.message
            )
        }
    }
)

export const fetchAddressById = createAsyncThunk<Address,number,{rejectValue:null}>(
    "/addresses/fetchAddressById",
    async(addressId,{rejectWithValue})=>{
        try {
            const response = await api.get(`${BASE_URL}/${addressId}`)
          
        return response.data;
        } catch (error:any) {
         
            return rejectWithValue(
                error.response.data.message
            )
        }
    }
)

const initialState:initialAddressState= {
    addresses:[],
    address:null,
    loading:false,
    error:null,
    isDeleted:false,
    message:null
}

export const AddressSlice = createSlice({
    name:"addresses",
    initialState,
    reducers:{},
    extraReducers:(builder) => {
        builder
        // add new address
        .addCase(addNewAddress.pending,(state)=>{
            state.loading= true
        })
        .addCase(addNewAddress.fulfilled,(state,action)=>{
            state.loading=false;
            state.address = action.payload
        })
        .addCase(addNewAddress.rejected,(state)=>{
            state.loading=false;
          
        })
        // deleteAddress
        .addCase(deleteAddress.pending,(state,action)=>{
            state.loading= true
        })
        .addCase(deleteAddress.fulfilled,(state,action)=>{
            state.loading=false;
            state.isDeleted = true;
            if(state.addresses){
                state.addresses.filter((address)=>address.id!=action.payload.id);
            }
        })
        .addCase(deleteAddress.rejected,(state,action)=>{
            state.loading=false;
            state.error = action.payload
        })

        // getAllAddress

        .addCase(fetchAllAddress.pending,(state,action)=>{
            state.loading= true;
            state.message = null
        })
        .addCase(fetchAllAddress.fulfilled,(state,action)=>{
            state.loading=false;
            state.addresses = action.payload
            state.isDeleted=false
        })
        .addCase(fetchAllAddress.rejected,(state,action)=>{
            state.loading=false;
            state.error = action.payload
        })

        // fetchAddressById

        .addCase(fetchAddressById.pending,(state,action)=>{
            state.loading= true;
            state.message = null
        })
        .addCase(fetchAddressById.fulfilled,(state,action)=>{
            state.loading=false;
            state.address = action.payload
            state.isDeleted=false
        })
        .addCase(fetchAddressById.rejected,(state,action)=>{
            state.loading=false;
            state.error = action.payload
        })
      }
})

export const addressSliceReducer = AddressSlice.reducer